import { GridComparatorFn } from "@mui/x-data-grid-pro";
import { DisplayMaintenance } from "@/models/MaintenanceDisplayData";

type Key = { hasJobs: boolean; hasOpen: boolean; maxSeverity: number };

function getKey(m?: DisplayMaintenance): Key {
  const jobs = m?.workOrderJobs ?? [];
  const hasJobs = jobs.length > 0;
  const hasOpen = hasJobs && jobs.some(j => j?.statusCode === 1);
  const maxSeverity = hasJobs ? Math.max(...jobs.map(j => j?.severityCode ?? 0)) : 0;
  return { hasJobs, hasOpen, maxSeverity };
}

function rank(m?: DisplayMaintenance) {
  const { hasJobs, hasOpen, maxSeverity } = getKey(m);
  return (hasJobs ? 1 : 0) * 1_000_000 + (hasOpen ? 1 : 0) * 10_000 + maxSeverity;
}

export const maintenanceSortComparator: GridComparatorFn<DisplayMaintenance | undefined> = (a, b) =>
  rank(a) - rank(b);
